import { render, staticRenderFns } from "./pieChartHospital.vue?vue&type=template&id=33baf868&scoped=true"
import script from "./pieChartHospital.vue?vue&type=script&lang=js"
export * from "./pieChartHospital.vue?vue&type=script&lang=js"
import style0 from "./pieChartHospital.vue?vue&type=style&index=0&id=33baf868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33baf868",
  null
  
)

export default component.exports